import { useEffect, useState } from "react";

import { getPartnerProjectionApi } from "../../api/apiEndpoints";
import { Projection, projectionFromResponse } from "../../utils/partnerMetrics";

export const useProjection = (businessId: string | undefined, enabled: boolean) => {
  const [projection, setProjection] = useState<Projection | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setProjection(null);
    if (!businessId || !enabled) return;
    setLoading(true);
    getPartnerProjectionApi(businessId)
      .then((res) => !cancelled && setProjection(projectionFromResponse(res.data)))
      .catch(() => !cancelled && setProjection(null))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [businessId, enabled]);

  return { projection, loading };
};
